import { Component, NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';

import { NameComponent } from './name.component';

//services
import { TitleService } from '../../hospitalSetup/titles-codes/title.service';
import { DictionaryService } from '../../gl/dictionaries/dictionary.service';


@NgModule({  
    imports: [SharedModule],
    declarations: [NameComponent],
    providers: [TitleService, DictionaryService],
    exports: [NameComponent]
})
export class NamesComponent { }


